<template>
    <div class="col-md-12 p-0 mt-5 mx-auto" style="border: none!important;">
        <h6>لیست بسته های من</h6>
        <v-card :loading="loading" class="p-3 pt-0">

            <terminal-table class="col-12" :currentPage="datas.current_page"
                            :perPage="datas.per_page" v-if="isMobile" :getData="getMyPacks"
                            :pageCount="datas.last_page"
                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

            <data-table
                    v-else
                    :data="datas"
                    :columns="columns"
                    :debounce-delay="3000"
                    :translate="translate"
                    :pagination="paginate"
                    :orderBy="tableProps.column"
                    :orderDir="tableProps.dir"
                    :per-page="[10, 25, 50, 100, 500]"
                    @on-table-props-changed="reloadTable"
                    class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
            </data-table>
        </v-card>
    </div>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";
import {debounce} from "../../../custom";

export default {
    name: "myPacks",
    components: {TitleRibbon, button, dataTableProps},
    props: {
        category: {
            default: ''
        },
        city: {
            default: ''
        },
        neighborhood: {
            default: ''
        },
        all: {
            default: false,
        },
        ladder: {
            default: false,
        }
    },
    data() {
        return {
            translates: [],
            url: `${url}/number/packs`,
            datas: {},
            loading:false,
            translate: dataTableProps.translate,
            paginate: dataTableProps.pagination,
            tableProps: dataTableProps.tableProps,
            selectedAds: [],
            dataId: '',
            columns: [
                {
                    isCheckBox:true,
                    label: '<input type="checkbox" id="selectAll">',
                    transform: (val) => {
                        return `<input type="checkbox" name="checkIt" data-id="${val.data.id}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'بسته',
                    name: 'number_pack.title',
                    transform: (val) => {
                        return val.data.number_pack.title ? val.data.number_pack.title : 'وجود ندارد';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'تعداد خط',
                    name: 'total',
                    transform: (val) => {
                        return val.data.total ? val.data.total : '-';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان خرید',
                    name: 'created_at_p',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان انقضا',
                    name: 'expire_at_p',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'روزهای باقی مانده',
                    name: 'expire_at_diff',
                    transform(val) {
                        const color = val.data.expire_at_diff == '3 روز دیگر' ? 'orange' : 'green'
                        return `
                        <span class="badge text-white px-4" style="background-color: ${color}">${val.data.expire_at_diff}</span>

                        `
                    }
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    handler: this.actions,
                    event: "actions",
                    meta: {
                        permission_prefix: 'notification_',
                        buttons: [
                            {
                                name: 'refresh',
                                label: 'تمدید',
                                icon: 'retweet',
                                class: 'btn-outline-primary',
                                action: this.actions,
                            },
                        ]
                    }
                }
            ],
        }
    },
    methods: {
        getMyPacks(url = this.url, query = this.tableProps) {
            this.loading=true
            $.ajax({
                url: url,
                method: "GET",
                fn: this.getMyPacks,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token
                },
                success: (res) => {
                    this.datas = res.data;
                    this.loading=false
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getMyPacks(this.url, this.tableProps);
            }, 700);
        },
        actions(data, type) {
            if (type === 'refresh') {
                const uniq = data.uniq;
                if (uniq !== undefined) {
                    this.$modal.yesNo('تایید نهایی خرید!', ` آیا از تمدید بسته ${data.number_pack.title}  حاوی ${data.total} خط به قیمت ${new Intl.NumberFormat('en-US', {style: 'decimal'}).format((data.number_pack.price) * (data.total))} ریال اطمینان دارید؟`, 'neg').then((value) => {
                        if (value === true) {
                            $.ajax({
                                url: `${url}/shop/numbers/${uniq}/renew`,
                                type: 'POST',
                                fn: this.actions,
                                params: [data, type],
                                headers: {
                                    "ACCEPT": "application/json",
                                    "Authorization": Token
                                },
                                data: {
                                    uniq: uniq,
                                },
                                msg: true,
                                statusCode: {
                                    200: (data) => {
                                        this.reloadTable(this.tableProps);
                                    },
                                }
                            });
                        }
                    })
                } else
                    $.ajax({
                        url: `${url}/shop/number/slot/${data.id}`,
                        type: 'PUT',
                        fn: this.actions,
                        params: [data, type],
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        msg: true,
                        statusCode: {
                            200: (data) => {
                                this.reloadTable(this.tableProps);
                            },
                        }
                    });

            }
        }
    },
    computed:{
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getMyPacks(this.url);
                    return true
                case 'sm':
                    this.getMyPacks(this.url);
                    return true
                case 'md':
                    this.getMyPacks(this.url);
                    return false
                case 'lg':
                    this.getMyPacks(this.url);
                    return false
                case 'xl':
                    this.getMyPacks(this.url);
                    return false
            }
        },
    },
    mounted() {
        this.getMyPacks();

        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedAds = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedAds = []
            }
        });
        $(document).on('click', `input[name = 'checkIt']`, (element) => {
            if ($(element.target).is(':checked')) {
                const selectedPart = $(element.target).data('id');
                this.selectedAds.push(selectedPart);
            } else {
                $(element.target).prop('checked', false)
                this.selectedAds.splice(this.selectedAds.indexOf($(this).data('id')), 1)
            }
        });
    },
}
</script>

<style scoped>

</style>